<style lang="less" scoped>
    .container{
        text-align: center;
        /deep/ img {
            max-width: 100%;
        }
    }
    .container-fix{
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 999;
        background-color: rgba(55,55,55,.6);
    }
    .title{
        line-height: 24px;
        float: left;
        font-weight: bold;
        font-size: 14px;
    }
    .text-editor{
        background: white;
    }
    .container-fix .text-editor{
        display: inline-block;
        margin-top: 100px;
        padding: 5px;
        border-radius: 4px;
    }
    .handler{
        text-align: right;
        padding: 5px 0;
    }
</style>

<template>
  <div
    v-show="config.show"
    class="container"
    :class="{'container-fix': this.setting.fixed}"
  >
    <div class="text-editor">
      <div
        v-show="setting.show_handler"
        class="handler"
      >
        <span
          v-if="config.title"
          class="title"
        >
          {{ config.title }}
        </span>
        <Button
          size="small"
          icon="ios-cloud-upload"
          :type="btnType"
          @click.prevent.stop="save"
        >
          <span
            v-show="!isProcessing && !isSucceed && !isFailed"
            class="btn-text"
          >保存</span>
          <span
            v-show="isProcessing"
            class="btn-text"
          >保存中...</span>
          <span
            v-show="isSucceed"
            class="btn-text"
          >保存成功</span>
          <span
            v-show="isFailed"
            class="btn-text"
          >保存失败</span>
        </Button>
        <Button
          size="small"
          icon="md-close"
          @click.prevent.stop="dismiss"
        >
          结束编辑
        </Button>
      </div>
      <textarea
        :id="id"
        placeholder="备注..."
      />
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import Util from '../../libs/util'
  export default {
    props: {
      value: {
        type: String
      },
      config: {
        type: Object
      },
      text: {
        type: String
      },
      url: {
        type: String
      },
      params: {
        type: Object
      }
    },
    data() {
      return {
        id: 'editor' + this._uid,
        editor: null,
        editing_text: '',
        isProcessing: false,
        isSucceed: false,
        isFailed: false,

        setting: {
          show: false,
          fixed: true,
          show_handler: true,
          width: 700,
          // min_height: '300px',
          method: 'POST',
          timeout: 10000,
          base_path: Util.kind_editor_root_path,
          upload_json: Util.kind_editor_upload_path,
          afterUpload() {},
        }
      }
    },
    computed: {
      btnType() {
        if (this.isSucceed) {
          return 'success';
        } else if (this.isFailed) {
          return 'error';
        } else {
          return 'warning';
        }
      },
      ajaxConfig() {
        const config = {
          url: this.url,
          method: this.setting.method,
          timeout: this.setting.timeout,
        };
        if (config.method.toLowerCase() === 'post') {
          config.data = this.params;
        } else {
          config.params = this.params;
        }
        return config;
      }
    },
    watch: {
      text: function(newValue) {
        if (this.editor) {
          const html = newValue ? newValue : '';
          this.editor.html(html);
        }
      },
      value: function(newValue) {
        if (this.editor) {
          const html = newValue ? newValue : '';
          this.editor.html(html);
        }
      }
    },
    created() {
      this.initSetting();
    },
    mounted() {
      setTimeout(() => {
        this.init();
      }, 500);
    },
    methods: {
      initSetting() {
        this.config && Object.assign(this.setting, this.config);
        if (typeof this.setting.width === 'number') {
          this.setting.width += 'px';
        }
      },
      init() {
        const options = {
          afterBlur: () => {
            if (this.editor) {
              const html = this.getHtml();
              this.$emit('update:text', html);
              this.$emit('input', html);
            }
          },
          basePath: this.setting.base_path,
          uploadJson: this.setting.upload_json,
          afterUpload: this.setting.afterUpload,
          // minHeight: this.setting.min_height,
          width: this.setting.width,
          langType : 'zh-CN',
          fontSizeTable: ['9px', '10px', '12px', '14px', '16px', '18px', '20px', '24px', '28px', '32px', '36px', '40px'],
          items: [
            'source', '|', 'undo', 'redo', '|', 'preview', 'print', 'template', 'code', 'cut', 'copy', 'paste',
            'plainpaste', 'wordpaste', '|', 'justifyleft', 'justifycenter', 'justifyright',
            'justifyfull', 'insertorderedlist', 'insertunorderedlist', 'indent', 'outdent', 'subscript',
            'superscript', 'clearhtml', 'quickformat', 'selectall', '|', 'fullscreen', '/',
            'formatblock', 'fontname', 'fontsize', '|', 'forecolor', 'hilitecolor', 'bold',
            'italic', 'underline', 'strikethrough', 'lineheight', 'removeformat', '|', 'image',
            'table', 'hr', 'emoticons', 'baidumap', 'pagebreak',
            'anchor', 'link', 'unlink', '|', 'about'
          ]
        };
        this.editor = kindEditor.create('#' + this.id, options);
        this.editor.html(this.text || this.value);
      },
      dismiss: function() {
        const html = this.getHtml();
        this.$emit('textchange', html, this.config.key);
        this.$emit('update:text', html);// 支持sync双向绑定
        this.$emit('input', html);
        this.$emit('close')
        this.config.show = false;
      },
      getHtml() {
        return this.editor.html().replace(/font-family[\s\S]+?\;/g, '').replace(/background[\s\S]+?FFFF\;/g, '').replace(/<hr \/>\n\t<br \/>\n/, '<hr \/>\n\t');
      },
      save() {
        const html = this.getHtml();
        this.$emit('update:text', html);
        this.$emit('input', html);
        if (!this.url) {
          this.$Message.error('请在 props 中指定 URL 路径');
          return;
        }
        if (!this.isProcessing && !this.isSucceed) {
          this.isProcessing = true;
          Util.ajax(this.ajaxConfig).then((response) => {
            return response.data;
          }).then((res) => {
            this.isProcessing = false;
            if (res.code === 1) {
              const data = res.data;
              this.isSucceed = true;
              this.$emit('done', data);
              setTimeout(() => {
                this.isSucceed = false;
              }, 500);
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            console.log(e);
            this.isProcessing = false;
            this.isFailed = true;
            this.$emit('fail', e);
            setTimeout(() => {
              this.isFailed = false;
            }, 2000);
          });
        }
      }
    }
  }


</script>
